import {Component, ChangeDetectionStrategy, SimpleChanges, OnChanges} from '@angular/core';
import {FormBuilder } from '@angular/forms';

import {GenericFieldset, IGenericFieldset} from '../generic-fieldset.component';
import {Yii} from "libraries/interfaces/Yii";

/**
 * Keyword-fieldset
 * Generate a fieldset of needed fields
 * @extends GenericFieldset
 * @implements IGenericFieldset
 */
@Component({
    selector: 'host-fieldset',
    template: `
        <div [formGroup]="group" class="price-fs">
            <div class="col-to-row-s-tb" *ngIf="config.title">
                <div class="col-md-12">
                    <h2 class="form-title">{{ config.title }}</h2>
                </div>
            </div>
            <div class="col-to-row-s-tb ctn-top">
                <div class="rm-marge-right flex-2">
                    <multiselect-field
                        [group]="group" controlName="host"
                        [options]="options"></multiselect-field>
                </div>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HostFieldsetComponent extends GenericFieldset implements IGenericFieldset, OnChanges {
    /** Readonly context can't be modified. Define the context of the fieldset */
    public readonly context: string = 'price';

    public placeholder: string = Yii.t('wui-shared-js', 'Aucune source');

    /** DI - Formbuilder */
    constructor(public fb: FormBuilder) {
        super(fb);
    }


    public ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.fieldsetData &&
            changes.fieldsetData.currentValue) {
            this.group.get('host').patchValue(changes.fieldsetData.currentValue);
        }
    }
}
